<div class="filter-item">
  <span class="input-label">{{ filterItem.caption }}</span>

  <div class="input-wrap select">
    <select
      class="input"
      [(ngModel)]="value"
      (ngModelChange)="onValueChanged()"
    >
      <option [value]="''" selected="selected">
        {{ filterItem.placeholder }}
      </option>

      <option *ngFor="let option of filterItem.values" [value]="option">
        {{ option }} Days
      </option>
    </select>
  </div>
</div>
